import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
import AddOrderNumberDetails from "./AddGovtOrderDispatch";
import UpdateGovtOrderDispatch from "./UpdateGovtOrderDispatch";
import { sweetAlert } from "../../Common/Utills/Utills";
import _ from "lodash";
import { minDate } from "../../Constants/Constants";
import Pagination from "../../Common/Pagination/Pagination";

const GovtOrderDispatch = () => {
  const [orderDetails, setOrderDetails] = useState([]);
  const params = useParams();
  const formRef = useRef(null);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowId, setRowId] = useState("");
  const [rowData, setRowData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [showSearch, setShowSearch] = useState(false);
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + rowData?.length - 1, totalRecords);
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate(-1);
  };

  const [orderId, setOrderId] = useState(params.id);
  const [filterCriteria, setfilterCriteria] = useState({
    order_number_id: parseInt(orderId),
  });
  const getSingleData = async () => {
    let BASE_URL =
      SERVER_URL +
      `/api/govt-order/single-govt-order-number/${user_id}/${orderId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setOrderDetails(result.data);
    } else {
      setOrderDetails([]);
    }
  };

  useEffect(() => {
    if (orderId) {
      getSingleData();
    }
  }, [params]);

  // useEffect(() => {
  //   setfilterCriteria({
  //     order_number_id: orderDetails?.id,
  //   });
  // }, [orderDetails]);

  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
    // gridRef.current.api.showLoadingOverlay();
  };

  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    // gridRef.current.api.showLoadingOverlay();
    setCurrentPage(1); // Reset to the first page when page size changes
  };

  const getData = async () => {
    const nonEmptyFilterCriteria = Object.fromEntries(
      Object.entries(filterCriteria).filter(
        ([key, value]) => value !== null && value !== undefined && value !== "",
      ),
    );
    const options = {
      whereFilters: nonEmptyFilterCriteria,
      skip: currentPage,
      take: pageSize,
    };
    let BASE_URL =
      SERVER_URL + `/api/govt-dispatch/all-govt-order-dispatch/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(options),
    });
    const result = await res.json();
    if (res.ok) {
      setTotalRecords(result.total);
      setRowData(result.data);
    } else {
      setRowData([]);
    }
  };
  const deleteOrderNumberData = async (order_id) => {
    const message = "Do you want to delete this dispatch details!";

    const result = await sweetAlert(message);

    if (!result.isConfirmed) {
      return;
    }
    let BASE_URL =
      SERVER_URL + `/api/govt-dispatch/govt-order-dispatch/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: order_id,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
    }
  };
  useEffect(() => {
    if (orderId) {
      const fecthDebounced = _.debounce(getData, 500);
      fecthDebounced();
      return () => {
        fecthDebounced.cancel();
      };
    }
  }, [currentPage, pageSize, filterCriteria]);

  const addDataToModal = (id) => {
    setRowId(id);
  };
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            View Govt Order Dispatch &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleNavigate}
              >
                <i
                  className="mdi mdi-arrow-left"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
                Back{" "}
              </button>
            </span>
          </div>
          <div className="form-container">
            <form className="form-sample">
              {/* <p className="card-description">Personal info</p> */}
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="order_number">Order Number</label>
                    <input
                      type="text"
                      className="form-control"
                      name="order_number"
                      id="order_number"
                      value={orderDetails?.order_number}
                      readOnly
                      placeholder="Alloted Quantity"
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="total_order_qty">Order Qty</label>
                    <input
                      type="text"
                      className="form-control"
                      name="total_order_qty"
                      id="total_order_qty"
                      placeholder="Order Qty"
                      value={orderDetails?.total_order_qty}
                      readOnly
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="product_name">Size</label>
                    <input
                      type="text"
                      className="form-control"
                      name="product_name"
                      id="product_name"
                      placeholder="Product Name"
                      value={orderDetails?.govtOrderDetails?.product_name}
                      readOnly
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="date">Date</label>
                    <input
                      type="text"
                      className="form-control"
                      name="date"
                      id="date"
                      placeholder="Date"
                      value={orderDetails?.date}
                      readOnly
                      min={minDate}
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="card mt-2">
        <div className="private-table-container">
          <div className="card-body">
            <div className="table_btn">
              <div className="mb-3">
                <button
                  data-toggle="modal"
                  data-target="#exampleModal"
                  className="btn btn-outline-primary"
                >
                  <span className="mr-1">
                    <i className="mdi mdi-briefcase-upload" />
                  </span>
                  Add Order Dispatch
                </button>
              </div>
              <div
                style={{
                  marginBottom: "20px",
                }}
              ></div>
            </div>
            <div
              className="table-responsive table-bordered govt-table"
              style={{ border: "0.05px solid lightGray", width: "auto" }}
            >
              <table className="table">
                <thead>
                  <tr>
                    <th rowSpan={2}>S.NO</th>
                    <th rowSpan={2}>Order Number</th>
                    <th rowSpan={2}>Dispatch Date</th>
                    <th colSpan={6} style={{ textAlign: "center" }}>
                      Dispatch Details
                    </th>
                    <th rowSpan={2}>Total Dispatch Quantity</th>
                    <th rowSpan={2}>Dispatch Balance</th>
                    <th rowSpan={2}>GP Number</th>
                    <th rowSpan={2}>Invoice Qty</th>
                    <th rowSpan={2}>Invoice Date</th>
                    <th rowSpan={2}>Invoice Number</th>
                    <th rowSpan={2}>Vehicle Number</th>
                    <th rowSpan={2}>Remarks</th>
                    <th rowSpan={2} style={{ textAlign: "center" }}>
                      Actions
                    </th>
                  </tr>
                  <tr>
                    <th>Yard Name</th>
                    <th>Company Name</th>
                    <th>Dispatch Qty</th>
                    <th>Over Stock</th>
                    <th>Shortage Stock</th>
                    <th>Damage Stock</th>
                  </tr>
                </thead>
                <tbody>
                  {rowData && rowData?.length > 0 ? (
                    rowData &&
                    rowData.length > 0 &&
                    rowData.map((detail, detailIndex) => (
                      <React.Fragment key={detailIndex}>
                        {detail?.dispatch_details.map(
                          (orderDetail, orderIndex) => {
                            const dispatchLen = detail.dispatch_details.length;
                            return (
                              <tr key={orderIndex}>
                                {orderIndex === 0 && (
                                  <>
                                    <td rowSpan={dispatchLen}>
                                      {detailIndex + 1}
                                    </td>
                                    <td rowSpan={dispatchLen}>
                                      {detail?.govtOrderNumber?.order_number}
                                    </td>
                                    <td rowSpan={dispatchLen}>
                                      {detail?.dispatch_date}
                                    </td>
                                  </>
                                )}
                                <td>{orderDetail.yard_name}</td>
                                <td>{orderDetail.company_name}</td>
                                <td>{orderDetail.dispatch_qty}</td>
                                <td>{orderDetail.p_over_stock}</td>
                                <td>{orderDetail.p_shortage_stock}</td>
                                <td>{orderDetail.p_damage_stock}</td>
                                {orderIndex === 0 && (
                                  <>
                                    <td rowSpan={dispatchLen}>
                                      {detail.total_dispatch_qty}
                                    </td>
                                    <td rowSpan={dispatchLen}>
                                      {detail.dispatch_balance}
                                    </td>
                                    <td rowSpan={dispatchLen}>
                                      {detail.gp_number}
                                    </td>
                                    <td rowSpan={dispatchLen}>
                                      {detail.invoice_qty}
                                    </td>
                                    <td rowSpan={dispatchLen}>
                                      {detail.invoice_date}
                                    </td>
                                    <td rowSpan={dispatchLen}>
                                      {detail.invoice_number}
                                    </td>
                                    <td rowSpan={dispatchLen}>
                                      {detail?.vehicleDetails?.vehicle_number}
                                    </td>
                                    <td rowSpan={dispatchLen}>
                                      {detail.remarks ? detail.remarks : "-"}
                                    </td>
                                    <td
                                      rowSpan={dispatchLen}
                                      style={{
                                        verticalAlign: "middle",
                                        textAlign: "center",
                                      }}
                                    >
                                      <span>
                                        <button
                                          className="btn btn-outline-secondary btn-sm ml-2"
                                          onClick={() =>
                                            addDataToModal(detail.id)
                                          }
                                          data-toggle="modal"
                                          data-target="#update"
                                        >
                                          <i className="mdi mdi-note-edit-outline" />
                                        </button>{" "}
                                        <button
                                          className="btn btn-outline-danger btn-sm ml-2"
                                          onClick={() =>
                                            deleteOrderNumberData(detail.id)
                                          }
                                        >
                                          <i className="mdi mdi-delete" />
                                        </button>
                                      </span>
                                    </td>
                                  </>
                                )}
                              </tr>
                            );
                          },
                        )}
                      </React.Fragment>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="18">
                        <div className="loading-container">
                          <p>No row to show</p>
                        </div>
                      </td>
                    </tr>
                  )}
                  <tr className="total-row">
                    <td colSpan={9} className="total-cell">
                      Total
                    </td>
                    <td>
                      {rowData?.reduce(
                        (total, item) =>
                          total + parseInt(item.total_dispatch_qty),
                        0,
                      )}
                    </td>
                    <td>
                      {rowData.length > 0 &&
                        rowData[rowData.length - 1].dispatch_balance}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <AddOrderNumberDetails
              formRef={formRef}
              govt_order_details_id={orderDetails.id}
              productName={orderDetails?.govtOrderDetails?.product_name}
              getData={getData}
              orderId={orderId}
              setOrderId={setOrderId}
            />
            <UpdateGovtOrderDispatch
              rowId={rowId}
              setRowId={setRowId}
              getData={getData}
              govt_order_details_id={orderDetails.id}
              productName={orderDetails?.govtOrderDetails?.product_name}
            />
          </div>
        </div>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          totalPages={totalPages}
          startItem={startItem}
          endItem={endItem}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
    </>
  );
};

export default GovtOrderDispatch;
